export const AUTH_STORAGE_KEYS = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  sessionId: 'sessionId',
  legacyToken: 'token',
  userInfo: 'User_Info',
  userFullInfo: 'User_Full_Info',
}

export const AUTH_ERROR_CODES = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  TOKEN_INVALID: 'TOKEN_INVALID',
  TOKEN_REVOKED: 'TOKEN_REVOKED',
  USER_DELETED: 'USER_DELETED',
  USER_DISABLED: 'USER_DISABLED',
  REFRESH_REJECTED: 'REFRESH_REJECTED',
  REFRESH_REUSED: 'REFRESH_REUSED',
  SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
  FORBIDDEN: 'FORBIDDEN',
}

export const HARD_LOGOUT_401_CODES = new Set([
  AUTH_ERROR_CODES.AUTH_REQUIRED,
  AUTH_ERROR_CODES.TOKEN_INVALID,
  AUTH_ERROR_CODES.TOKEN_REVOKED,
  AUTH_ERROR_CODES.USER_DELETED,
  AUTH_ERROR_CODES.USER_DISABLED,
  AUTH_ERROR_CODES.REFRESH_REJECTED,
  AUTH_ERROR_CODES.REFRESH_REUSED,
  AUTH_ERROR_CODES.SESSION_NOT_FOUND,
])
